// This catalogue only provides human-readable labels. The backend's
// `allowed_tools` response remains the sole source of authorization truth.
export const MCP_TOOL_GROUPS = {
  trainings: {
    label: 'Formations et contenus',
    icon: 'graduation-cap',
  },
  bundles: {
    label: 'Packs',
    icon: 'boxes',
  },
  // Abonnements : désactivé temporairement
  // memberships: {
  //   label: 'Abonnements',
  //   icon: 'calendar-check',
  // },
  students: {
    label: 'Apprenants et résultats',
    icon: 'user-graduate',
  },
  sales: {
    label: 'Ventes et codes promo',
    icon: 'chart-line',
  },
  affiliates: {
    label: 'Affiliation',
    icon: 'users',
  },
  settings: {
    label: 'Réglages de paiement',
    icon: 'cog',
  },
  other: {
    label: 'Autres outils',
    icon: 'puzzle-piece',
  },
};

export const MCP_TOOL_DETAILS = {
  list_trainings: {
    group: 'trainings',
    label: 'Lister les formations',
    description: 'Voir les formations accessibles, leurs statuts, tarifs, compteurs et liens.',
  },
  get_training: {
    group: 'trainings',
    label: 'Consulter une formation',
    description: 'Lire les informations et contenus d’une formation accessible.',
  },
  search: {
    group: 'trainings',
    label: 'Rechercher dans le catalogue',
    description: 'Repérer les formations et contenus qui correspondent à une recherche.',
  },
  fetch: {
    group: 'trainings',
    label: 'Ouvrir un résultat de recherche',
    description: 'Lire le résultat précis retrouvé par la recherche.',
  },
  get_content_block_schema: {
    group: 'trainings',
    label: 'Consulter les formats de contenu',
    description: 'Connaître les blocs de contenu acceptés avant une création ou modification.',
  },
  create_training: {
    group: 'trainings',
    label: 'Créer une formation',
    description: 'Préparer une nouvelle formation en brouillon.',
  },
  create_training_items: {
    group: 'trainings',
    label: 'Ajouter du contenu à une formation',
    description: 'Créer les éléments de contenu autorisés dans une formation accessible.',
  },
  update_training: {
    group: 'trainings',
    label: 'Modifier une formation',
    description: 'Modifier les informations autorisées d’une formation accessible.',
  },
  update_training_items: {
    group: 'trainings',
    label: 'Modifier le contenu d’une formation',
    description: 'Mettre à jour les éléments autorisés d’une formation accessible.',
  },
  reorder_trainings: {
    group: 'trainings',
    label: 'Réordonner les formations',
    description: 'Changer l’ordre des formations dans le catalogue.',
  },
  reorder_training_items: {
    group: 'trainings',
    label: 'Réordonner les chapitres et contenus',
    description: 'Changer l’ordre des chapitres, leçons et autres contenus.',
  },
  upload_training_image: {
    group: 'trainings',
    label: 'Téléverser une image pour une leçon',
    description: 'Ajouter une image fournie et confirmée par vos soins à un contenu.',
  },
  list_bundles: {
    group: 'bundles',
    label: 'Lister les packs',
    description: 'Voir les packs et les formations qu’ils contiennent.',
  },
  get_bundle: {
    group: 'bundles',
    label: 'Consulter un pack',
    description: 'Lire les informations, tarifs et formations d’un pack.',
  },
  create_bundle: {
    group: 'bundles',
    label: 'Créer un pack',
    description: 'Préparer un nouveau pack en brouillon.',
  },
  update_bundle: {
    group: 'bundles',
    label: 'Modifier un pack',
    description: 'Modifier un pack selon les mêmes règles que dans Teachizy.',
  },
  list_students: {
    group: 'students',
    label: 'Lister les apprenants',
    description: 'Rechercher les apprenants visibles et leurs inscriptions accessibles.',
  },
  get_student_results: {
    group: 'students',
    label: 'Consulter les résultats d’un apprenant',
    description: 'Lire les progressions et résultats accessibles d’un apprenant précis.',
  },
  get_student: {
    group: 'students',
    label: 'Consulter la fiche d’un apprenant',
    description: 'Lire ses inscriptions et sa progression dans les formations accessibles.',
  },
  get_student_activity: {
    group: 'students',
    label: 'Consulter l’activité d’un apprenant',
    description: 'Lire ses sessions et dates de progression dans une formation accessible.',
  },
  invite_student: {
    group: 'students',
    label: 'Inviter un apprenant',
    description: 'Inscrire un apprenant et préparer son courriel d’invitation.',
  },
  // Abonnements : désactivé temporairement
  // list_memberships: {
  //   group: 'memberships',
  //   label: 'Lister les abonnements',
  //   description: 'Voir les offres d’abonnement, leurs prix, leur contenu et leur nombre d’abonnés.',
  // },
  // list_membership_subscribers: {
  //   group: 'memberships',
  //   label: 'Lister les abonnés',
  //   description: 'Voir les abonnés, leur état (actif, impayé, annulation programmée…) et le prix payé.',
  // },
  // get_membership_stats: {
  //   group: 'memberships',
  //   label: 'Analyser les abonnements',
  //   description: 'Consulter le revenu mensuel récurrent, les impayés, les nouveaux abonnés et les annulations.',
  // },
  list_discount_codes: {
    group: 'sales',
    label: 'Lister les codes promo',
    description: 'Voir les codes promo et leur utilisation.',
  },
  create_discount_code: {
    group: 'sales',
    label: 'Créer un code promo',
    description: 'Créer un code promo dans les limites de l’offre.',
  },
  get_sales_stats: {
    group: 'sales',
    label: 'Analyser les ventes',
    description: 'Consulter les statistiques de ventes autorisées.',
  },
  list_sales: {
    group: 'sales',
    label: 'Lister les ventes',
    description: 'Voir les ventes, les apprenants et leurs données UTM.',
  },
  get_training_stats: {
    group: 'sales',
    label: 'Analyser une formation',
    description: 'Consulter les statistiques des formations accessibles.',
  },
  list_affiliates: {
    group: 'affiliates',
    label: 'Lister les affiliés',
    description: 'Voir les affiliés de l’espace et leurs réglages accessibles.',
  },
  get_affiliate_stats: {
    group: 'affiliates',
    label: 'Analyser l’affiliation',
    description: 'Consulter les statistiques d’affiliation autorisées.',
  },
  create_affiliate: {
    group: 'affiliates',
    label: 'Ajouter un affilié',
    description: 'Ajouter un affilié avec les réglages autorisés.',
  },
  update_affiliate: {
    group: 'affiliates',
    label: 'Modifier un affilié',
    description: 'Modifier le statut et les commissions d’un affilié.',
  },
  get_payment_settings: {
    group: 'settings',
    label: 'Consulter les réglages de paiement',
    description: 'Voir les réglages de paiement non secrets de l’espace.',
  },
  update_payment_settings: {
    group: 'settings',
    label: 'Modifier les réglages de paiement',
    description: 'Modifier les réglages de paiement pris en charge.',
  },
  delete_payment_schedule: {
    group: 'settings',
    label: 'Supprimer une option de paiement en plusieurs fois',
    description: 'Retirer une option de paiement d’une formation ou d’un pack après confirmation.',
  },
};

export function describeMcpTool(name) {
  const details = MCP_TOOL_DETAILS[name] || {
    group: 'other',
    label: name.replace(/_/g, ' '),
    description: 'Outil autorisé pour ce compte par Teachizy.',
  };
  const group = MCP_TOOL_GROUPS[details.group] || MCP_TOOL_GROUPS.other;

  return {
    ...details,
    icon: group.icon,
    name,
  };
}
